import { render } from "./NjnpView.vue?vue&type=template&id=11ef5b6a"
import script from "./NjnpView.vue?vue&type=script&lang=js"
export * from "./NjnpView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__